import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import AdCaller from 'helpers/ads/adCaller';
import WithDelay from 'helpers/hoc/WithDelay';
import Cookie from 'utils/cookies';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import makeRequest from 'utils/makeRequest';
import s from './Footer.scss';
import { IMAGE_URL, UNIFIED_FEED_DOMAIN } from '../../../constants';
import { getSectionName } from '../../../utils/common';
import Socials from '../../../components_v2/desktop/Header/Socials/Socials';
import ResourceLinks from '../../../components_v2/common/ResourceLinks';

// import ElementInView from '../../../components_v2/common/ElementInView';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showunderToneAd: false,
    };
  }
  componentDidMount() {
    window.times = window.times || {};
    window.times.cookie = window.times.cookie || {};
    window.times.cookie.set = window.times.cookie.set || Cookie.set;

    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      (typeof window.geoinfo.CountryCode === 'string' ||
        typeof window.geoinfo.region_code === 'string')
    ) {
      if (
        window.geoinfo.CountryCode === 'US' &&
        window.geoinfo.region_code === 'CA'
      ) {
        this.addAdditionalLinks();
      }
      if (
        window.geoinfo.CountryCode === 'US' ||
        window.geoinfo.CountryCode === 'CA'
      ) {
        this.setState({
          showunderToneAd: true,
        });
      }
    }

    const { footerData } = this.props;
    if (
      footerData &&
      footerData.lastSectionItems &&
      Array.isArray(footerData.lastSectionItems.items)
    ) {
      this.initIntervalUpdation();
    }
  }
  initIntervalUpdation = () => {
    setInterval(() => {
      const url = `${UNIFIED_FEED_DOMAIN}/wufs/top-news/fetch/latest/articles/toi`;
      makeRequest.get(url, {}).then(response => {
        if (response && Array.isArray(response.data)) {
          this.setState({
            lastSectionItems: {
              label: 'Latest News',
              items: response.data.slice(0, 18),
            },
          });
        }
      });
    }, 600000);
  };

  addAdditionalLinks = () => {
    if (
      this.props.footerData?.siteLinks?.items &&
      Array.isArray(this.props.footerData.siteLinks.items)
    )
      this.props.footerData.siteLinks.items.push(
        // {
        //   wu: 'https://timesofindia.indiatimes.com/donotsell.cms',
        //   hl: 'Do Not Sell Data',
        // },
        {
          wu: 'https://timesofindia.indiatimes.com/cookie-policy',
          hl: 'Cookie Policy',
        },
      );
  };

  renderSection = secData => {
    const columnData = [];
    const secLabelForGA = secData.label ? secData.label : 'TOI';
    if (secData && secData.items && secData.items.length > 0) {
      secData.items.forEach(col => {
        columnData.push(
          <Link
            to={col.eulink && this.props.isPrivateUser ? col.eulink : col.wu}
            key={col.wu}
            className={col.cls}
            data-newga={`Footer_Actions#${secLabelForGA}-${col.hl}`}
          >
            {col.hl}
          </Link>,
        );
      });
      return (
        <div className={`${s.section}`} key={secData.label}>
          {secData.label ? (
            <h4 className={s.section_heading}>{secData.label}</h4>
          ) : null}
          <div className={s.section_items}>{columnData}</div>
        </div>
      );
    }
    return null;
  };

  renderIcons = icons => {
    const iconData = [];
    if (icons && icons.items && icons.items.length > 0) {
      icons.items.forEach(icon => {
        iconData.push(
          <Link
            className={`${s.footer_icon} ${icon.type}`}
            to={icon.wu}
            title={icon.hl}
            data-newga={`Footer_Actions#SocialMedia-${icon.hl}`}
            key={icon.hl}
            target="_blank"
          />,
        );
      });
      return (
        <div className={s.social_wrapper}>
          {icons.label ? (
            <h4 className={s.section_heading}>{icons.label}</h4>
          ) : null}
          <div className={s.social_icons}>{iconData}</div>
        </div>
      );
    }
    return null;
  };
  // componentDidMount() {
  //   this.props.loadFooterData();
  // }
  render() {
    const { footerData, isReviewsPage } = this.props;
    const getFooterLogo = () => {
      if (isReviewsPage) {
        return `${IMAGE_URL}113492627.cms`;
      }
      return `${IMAGE_URL}111986287.cms`;
    };

    if (footerData) {
      const sections = [];
      if (footerData.sections && footerData.sections.length > 0) {
        footerData.sections.forEach((sec, index) => {
          const sectionClass = index < 2 ? 'smallView' : ''; // Apply 'smallView' only for the first two sections
          sections.push(
            <div key={index} className={s.section_item}>
              <ResourceLinks
                isReviewsPage={isReviewsPage}
                sectionData={sec}
                sectionClass={sectionClass}
              />
            </div>,
          );
        });
      }
      const sectionName = getSectionName(
        this.props.articleSectionData,
        this.props.newsData,
        this.props.msid,
        this.props.liveblogData,
      );
      return (
        <div data-translate-id="cw">
          <div className="contentwrapper">
            <InterSectionBorder />
          </div>

          <div className={`footer_wrapper contentwrapper `}>
            <div className="contentwrapper">
              {/* Across The Globe */}

              {footerData?.electionLiveblogsWidget?.items &&
                Array.isArray(footerData.electionLiveblogsWidget.items) &&
                footerData.electionLiveblogsWidget.items.length > 0 && (
                  <ResourceLinks
                    sectionData={footerData.electionLiveblogsWidget}
                  />
                )}

              <div
                className={`${s.footer_section} ${
                  isReviewsPage ? s.reviews_footer_section : ''
                }`}
              >
                <div>
                  {footerData.logo ? (
                    <Link
                      className={`${s.toilogo} ${
                        isReviewsPage ? s.reviewFooterLogo : ''
                      }`}
                      to={footerData.logo.link}
                      data-newga="Footer_Actions#TOI-logo"
                    >
                      <Image src={getFooterLogo()} alt="logo" lazyload />
                    </Link>
                  ) : null}
                  {footerData.siteLinks ? (
                    <ResourceLinks
                      sectionData={footerData.siteLinks}
                      sectionClass="smallView"
                    />
                  ) : null}
                </div>
                {isReviewsPage && sections.length < 2 && sections}

                {sections.length > 2
                  ? sections.slice(0, 2).map((section, index) => (
                      <div
                        key={index}
                        className={` ${s.section_item} other_two`}
                      >
                        {section}
                      </div>
                    ))
                  : ''}

                {/* <div className={`${s.footer_left_col}`}>
                  
                </div> */}
              </div>
              {sections.length > 2
                ? sections
                    .slice(2, sections.length)
                    .map((section, index) => <div key={index}>{section}</div>)
                : ''}

              {(footerData.lastSectionItems &&
                Array.isArray(footerData.lastSectionItems.items)) ||
              (this.state.lastSectionItems &&
                Array.isArray(this.state.lastSectionItems.items)) ? (
                <ResourceLinks
                  sectionData={footerData.lastSectionItems}
                  sectionClass="Threecolumn"
                />
              ) : null}

              {footerData.disclaimer ? (
                <div className={s.disclaimer}>
                  {footerData.disclaimer}
                  {/* {footerData.social ? this.renderIcons(footerData.social) : null} */}
                  {/* <ElementInView
                  gaCategory="web_bottom_footer_toi"
                  gaAction="social_profile_icons"
                  gaLabel="view"
                > */}
                  <InViewObserver
                    inViewCallback={() => {
                      analyticsWrapper('ga4', {
                        event: 'user_shown',
                        type: 'social_icons',
                        category: 'footer',
                      });
                    }}
                  >
                    <Socials
                      colorTheme="snowwhite"
                      showTitle
                      showKoo
                      showWiki
                      isFooter
                      sectionName={sectionName}
                      ga4Data={[
                        {
                          event: 'user_click',
                          type: 'social_share',
                          category: 'bottom_social',
                        },
                      ]}
                    />
                  </InViewObserver>
                  {/* </ElementInView> */}
                  {/* {footerData.otherTimesSite
                    ? this.renderSection(footerData.otherTimesSite)
                    : null} */}
                </div>
              ) : null}
            </div>
            {footerData.underTone &&
              this.state.showunderToneAd && (
                <WithDelay delay={3000}>
                  <AdCaller
                    immediateLoad
                    data={footerData.underTone}
                    deviceType="all"
                  />
                </WithDelay>
              )}
          </div>
        </div>
      );
    }

    return null;
  }
}

Footer.propTypes = {
  footerData: PropTypes.shape({}).isRequired,
  isReviewsPage: PropTypes.bool.isRequired,
  isPrivateUser: PropTypes.bool.isRequired,
};

export default Footer;
